var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProhibitedIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.9471 10c0 1.3795-.4601 2.6091-1.3077 3.6801-.0516.0651-8.3328-8.3559-8.3328-8.3559s-.3718.295-.5859.5098c-.2123.2129-.5039.582-.5039.582l8.3224 8.3292c-1.0559.8057-2.1961 1.1485-3.5392 1.1485-1.6162 0-3.0128-.5468-4.1556-1.6896S4.0736 11.6162 4.0736 10c0-1.3309.3513-2.5333 1.1432-3.584 0 0 .2916-.3691.5039-.582.2141-.2148.586-.5098.586-.5098 1.0836-.8216 2.3083-1.2637 3.6953-1.2637 1.6161 0 3.0848.5629 4.2276 1.7057S15.9471 8.3838 15.9471 10M2.5 10a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProhibitedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/prohibited-icon.8226dd1b18ad69610fe2ba320c852723.svg";